import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';

import { Restaurant } from 'PMT/entities';
import { OrderSettings } from 'PMT/entities/order';

//
// components
//
import AbstractOrderSettingsForm from './AbstractOrderSettingsForm';
import OpeningHoursForDay from 'components/openingHours/OpeningHoursForDay';
import AddOpeningHourModal from 'components/openingHours/AddOpeningHourModal';
import OpeningHoursForm from 'components/openingHours/OpeningHoursForm';

export default class OrderGeneralSettingsPage extends AbstractOrderSettingsForm {

  static propTypes = {
    restaurant: PropTypes.objectOf(Restaurant),

    orderSettings: PropTypes.objectOf(OrderSettings),

    onSubmit: PropTypes.func.isRequired
  };

  state = this.getDefaultState(this.props.orderSettings);

  //
  // events opening hours
  //

  onOpeningHoursChange = (openingHours: OpeningHours) => {
    const orderSettings: OrderSettings = this.orderSettings;

    orderSettings.openingHours = openingHours;

    this.setState({
      orderSettings
    });
  };

  //
  // Renderers
  //

  renderBody() {
    const openingsHours: OpeningHours = this.orderSettings.openingHours;

    return (
      <div>
        <OpeningHoursForm
          openingHours={openingsHours}
          onChange={this.onOpeningHoursChange}
          readOnly={!this.canEditSettings()}
        />

        {this.renderFixedButtons()}
      </div>
    );
  }

  render() {
    try {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  } catch (e) { console.error(e); }
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/components/OrderOpeningHoursSettingsPage.js